import React from 'react';

import { Icon } from '@swf/sports/components';
import type { IconName } from '@swf/sports/types/icon';

import type { Props as MenuLinkProps } from '../MenuLink/MenuLink';
import MenuLink from '../MenuLink/MenuLink';

import styles from './IconLink.scss';

export interface Props extends MenuLinkProps {
  text: string;
  icon: IconName;
}

const IconLink: React.FC<Props> = ({ icon, text, ...rest }) => (
  <MenuLink {...rest} activeClassName={styles.active}>
    <span className={styles.linkWrapper}>
      <Icon name={icon} className={styles.linkIcon} size="xl" />
      <span>{text}</span>
    </span>
  </MenuLink>
);

export default IconLink;
